module.exports = __webpack_public_path__ + "static/media/microscope-line.770fa9d9.svg";